/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardViolationsByAccountResponse {
    getFixupPrototypeFunction() { return SecurityDashboardViolationsByAccountResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardViolationsByAccountResponse>): SecurityDashboardViolationsByAccountResponse {
        let obj = Object.assign(new SecurityDashboardViolationsByAccountResponse(), model);
        SecurityDashboardViolationsByAccountResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardViolationsByAccountResponse>): SecurityDashboardViolationsByAccountResponse {
        if (!model) return null;
        return SecurityDashboardViolationsByAccountResponse.newInstance(<SecurityDashboardViolationsByAccountResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardViolationsByAccountResponse) {
        if (!obj) return;

        models.SecurityDashboardViolationsByAccountResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardViolationsByAccountResponse): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardViolationsByAccountResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.summary_by_accounts) {
            for (let val of this.summary_by_accounts) {
                models.SecurityDashboardViolationAccountDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Visibility of the Violations by Account
     */
    summary_by_accounts: Array<models.SecurityDashboardViolationAccountDetails>;

}
